import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import styled from 'styled-components';
import logo from '../../assets/kaquaslogo.png'

export default function Loading() {
  return (
    <Container>
      <Logo src={logo} />
      <Title>
        Data is begin load
      </Title>
      <SubTitle>
        Please wait a moment
      </SubTitle>
      <CircularProgress />
    </Container>
  );
}

 // <Box
    //   sx={{
    //     position: 'fixed',  // Ensure it covers the entire viewport
    //     top: 0,
    //     left: 0,
    //     width: '100vw',
    //     height: '100vh',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: Add a slight background color to highlight the loading state
    //     zIndex: 9999, // Ensure it's on top of other content
    //   }}
    // >      
// </Box>

    const Logo = styled.img`
      width:7vw;
      margin-bottom: 24px;
    `

    const Title = styled.div`
      margin-bottom: 1vw;
      font-size:1.8vw;
    `
    const SubTitle = styled.div`
      margin-bottom: 30px;
      font-size:1.8vw;
      text-align:center;
    `

    const Container = styled.div`
      position: fixed,
      width: 100%;
      height: 100vh;
      display:flex;
      flex-direction:column;
      align-items: center;
      justify-content: center;

    `